import {useContext} from "react";
import {
    Tab,
} from "semantic-ui-react";
import { Table } from "antd";
import {TemplateContext} from "../../../../utils/template_context";

const TabEducation = ({ datos, userState, handleOpenModal, handleCloseModal }: any) => {

    //console.log(userState)
    const context = useContext(TemplateContext);

    const columns: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "lg"? "left": false,
            width: 40,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Título',
            key: 'titulo',
            dataIndex: 'titulo',
            width: 300,
        },
        {
            title: 'Nivel de educación',
            key: 'nivel_educacion',
            dataIndex: 'nivel_educacion',
            width: 190,
        },
        {
            title: 'Institución educativa',
            key: 'institucion_educativa',
            dataIndex: 'institucion_educativa',
            width: 300,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
        {
            title: 'Graduado',
            key: 'graduado',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.graduado === true ? "si" : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de graduación',
            key: 'fecha_graduacion',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>
                    {datos.fecha_graduacion ?
                        (
                            <div>{datos.fecha_graduacion}</div>
                        )
                        :
                        (
                            <div>No aplica</div>
                        )
                    }
                </div>
            )
        },
        {
            title: 'Anexo',
            key: 'anexo',
            width: 100,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any, record: any, index: number) => (
                <button type="button" onClick={() => handleOpenModal(datos.path_anexo)}> Ver Anexo</button>
            )
        },
    ]

    const columnsSinAnexo: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "md"? "left": false,
            width: 50,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Título',
            key: 'titulo',
            dataIndex: 'titulo',
            width: 300,
        },
        {
            title: 'Nivel de educación',
            key: 'nivel_educacion',
            dataIndex: 'nivel_educacion',
            width: 190,
        },
        {
            title: 'Institución educativa',
            key: 'institucion_educativa',
            dataIndex: 'institucion_educativa',
            width: 300,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
        {
            title: 'Graduado',
            key: 'graduado',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.graduado === true ? "si" : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de graduación',
            key: 'fecha_graduacion',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>
                    {datos.fecha_graduacion ?
                        (
                            <div>{datos.fecha_graduacion}</div>
                        )
                        :
                        (
                            <div>No aplica</div>
                        )
                    }
                </div>
            )
        },
    ]

    const columns2: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "md"? "left": false,
            width: 60,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Nombre',
            key: 'nombre_educacion',
            dataIndex: 'nombre_educacion',
            width: 200,
        },
        {
            title: 'Proceso',
            key: 'nombre_proceso',
            dataIndex: 'nombre_proceso',
            width: 190,
        },
        {
            title: 'Duración',
            key: 'duracion',
            dataIndex: 'duracion',
            width: 150,
        },
        {
            title: 'Institución',
            key: 'institucion',
            dataIndex: 'institucion',
            width: 150,
        },
        {
            title: 'Fecha de inicio',
            key: 'fecha_inicio',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.fecha_inicio ? datos.fecha_inicio : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de terminación',
            key: 'fecha_terminacion',
            dataIndex: 'fecha_terminacion',
            width: 150,
        },
        {
            title: 'Número de horas',
            key: 'numero_horas',
            dataIndex: 'numero_horas',
            width: 150,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
        {
            title: 'Anexo',
            key: 'anexo',
            width: 100,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any, record: any, index: number) => (
                <button type="button" onClick={() => handleOpenModal(datos.path_anexo)}> Ver Anexo</button>
            )
        },
    ]
    const columns2SinAnexo: any = [
        {
            title: 'No.',
            key: 'index',
             fixed: context.device === "md"? "left": false,
            width: 60,
            render: (datos: any, record: any, index: number) => (
                <div>{index + 1}</div>
            )
        },
        {
            title: 'Nombre',
            key: 'nombre_educacion',
            dataIndex: 'nombre_educacion',
            width: 200,
        },
        {
            title: 'Proceso',
            key: 'nombre_proceso',
            dataIndex: 'nombre_proceso',
            width: 190,
        },
        {
            title: 'Duración',
            key: 'duracion',
            dataIndex: 'duracion',
            width: 150,
        },
        {
            title: 'Institución',
            key: 'institucion',
            dataIndex: 'institucion',
            width: 150,
        },
        {
            title: 'Fecha de inicio',
            key: 'fecha_inicio',
            width: 150,
            render: (datos: any, record: any, index: number) => (
                <div>{datos.fecha_inicio ? datos.fecha_inicio : "No aplica"}</div>
            )
        },
        {
            title: 'Fecha de terminación',
            key: 'fecha_terminacion',
            dataIndex: 'fecha_terminacion',
            width: 150,
        },
        {
            title: 'Número de horas',
            key: 'numero_horas',
            dataIndex: 'numero_horas',
            width: 150,
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            dataIndex: 'ciudad',
            width: 150,
        },
    ]



    const TabEducacionFormal = () => {


        return (
                <Table
                    dataSource={datos.educacion_formal}
                    columns={ userState ? columns : columnsSinAnexo}
                    scroll={{ x: 1500, y: 300 }}
                />
        );
    };
    const TabEducacionNoFormal = () => {
        return (
            <Table
                dataSource={datos.educacion_no_formal}
                columns={userState ? columns2 : columns2SinAnexo}
                scroll={{ x: 1500, y: 300 }}
            />
        );
    };
    const educationPanes = [
        {
            menuItem: "Educación formal",
            render: () => (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                    <TabEducacionFormal />
                </Tab.Pane>
            ),
        },
        {
            menuItem: "Educación no formal",
            render: () => (
                <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                    {" "}
                    <TabEducacionNoFormal />
                </Tab.Pane>
            ),
        },
    ];
    const EducationTabs = () => (
        <Tab
            panes={educationPanes}
            menu={{ secondary: true, pointing: true }}
            className="tabs-jurados"
            renderActiveOnly={true}
        />
    );
    return (
        <EducationTabs />
    );
};


export default TabEducation